import React from 'react';

import Icon, { Props } from './icon';

export const ArrowDownIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon viewBox="0 0 36 36" {...props}>
      <path
        d="M18,27.6c-0.3,0-0.7-0.1-1-0.4L3.5,13.7c-0.5-0.5-0.5-1.4,0-1.9s1.4-0.5,1.9,0L18,24.3l12.5-12.5
		c0.5-0.5,1.4-0.5,1.9,0c0.5,0.5,0.5,1.4,0,1.9L19,27.2C18.7,27.5,18.3,27.6,18,27.6z"
      />
    </Icon>
  );
};

export default ArrowDownIcon;
